import { useCallback, useMemo, useState } from 'react'
import * as React from 'react'

import SimpleDialog from '@/components/simple-dialog'

type ModalContent = {
  title: string;
  content: React.ReactNode;
  closeOnClickOutside: boolean;
};

export default function useModal(): [
  React.ReactNode,
  (title: string, getContent: (onClose: () => void) => React.ReactNode, closeOnClickOutside?: boolean) => void
] {
  const [modalContent, setModalContent] = useState<ModalContent | null>(null)

  const onClose = useCallback(() => {
    setModalContent(null)
  }, [])

  const modal = useMemo(() => {
    if (modalContent === null) {
      return null
    }
    const { title, content } = modalContent
    return (
      <SimpleDialog
        isOpen={true}
        closeModal={onClose}
        dialogTitle={title}
        maxWidth='sm'
        zIndex='z-[10001]'
      >
        {content}
      </SimpleDialog>
    )
  }, [modalContent, onClose])

  const showModal = useCallback(
    (
      title: string,
      getContent: (onClose: () => void) => React.ReactNode,
      closeOnClickOutside = false
    ) => {
      setModalContent({
        closeOnClickOutside,
        content: getContent(onClose),
        title
      })
    },
    [onClose]
  )

  return [modal, showModal]
}
